<template>
  <main>
    <h1 class="page-title">Make a payment request</h1>
    <p>Send a payment request via Email and receive payment in crypto.</p>
    <div>
      <vs-row class="mt-6">
        <vs-col
          type="flex"
          vs-justify="left"
          vs-align="center"
          vs-w="6"
          vs-xs="12"
          vs-sm="12"
          vs-lg="6"
          class="p-0">
          <vs-card v-if="paymentRequestCreated" class="pr-3 pl-3 pt-5 pb-2">
            <vs-row>
              <h5>
                Payment Request created ! How do you want to inform your payer
                of this payment request ?
              </h5>
            </vs-row>

            <vs-row
              vs-align="center"
              vs-type="flex"
              vs-justify="center"
              v-if="!sendEmailSuccessful"
              class="mt-8 mb-3">
              <vs-col vs-type vs-justify="center" vs-w="6" vs-xs="12">
                <vs-button class="w-100" type="border" @click="sendEmail()">
                  Send email to payer
                </vs-button>
              </vs-col>
            </vs-row>
            <vs-row vs-align="center" vs-type="flex" vs-justify="center" v-else>
              <h5>Email successfully sent !</h5>
            </vs-row>
            <vs-row vs-align="center" vs-justify="center" class="mt-5 mb-5">
              <strong>or</strong>
            </vs-row>
            <vs-row>
              <h6>Copy the following link and send it to your payer.</h6>
            </vs-row>
            <div vs-align="center" class="mt-5 pt-2 pb-2 link-url tooltip-copy-container" @click="copyLink()">
              <a :href="url" target="_blank" rel="noreferrer noopener">
                <span class="w-100 p-2">{{ url && url }}</span>
              </a>
              <vs-icon
                icon="content_copy"
                size="small"
                @click="copyLink()"
                style="cursor: pointer"></vs-icon>
              <div class="p-2 copiedMsg" v-if="displayCopiedMsg">
                <small>Copied!</small>
              </div>
            </div>
            <vs-row v-if="showInvoiceUploadField" class="mb-2">
              <span><small>Please note that the payer will have to upload their identity
                  document (for individual) or business registration document
                  (for company) for verification before payment*.</small></span>
              <span style="font-size: 0.7em; font-weight: 600">*This is only for payer who have not uploaded the document
                before.</span>
            </vs-row>
            <vs-row class="mt-12">
              <vs-button class="w-100" @click="createAnotherPaymentRequest()">Create another payment request</vs-button>
            </vs-row>
          </vs-card>
          <vs-card v-else>
            <div>
              <div
                style="
                  display: flex;
                  width: 100%;
                  justify-content: space-between;
                ">
                <span style="color: #ff0000; font-size: 0.9em"><small>* Required</small></span>
              </div>

              <div class="p-5">
                <div v-if="checkMerchantsToDisplay.length > 0">
                  <h4>
                    Which merchant should receive the payment ?<span
                      style="color: #ff0000">*</span>
                  </h4>

                  <select
                    id="account-selection"
                    class="accountSelection mb-3 w-full style-select"
                    v-model="selectedActiveMerchant">
                    <optgroup label="Merchants">
                      <option
                        v-for="(item, index) in merchantList"
                        :key="index"
                        :value="item"
                        v-if="checkMerchantsToDisplay.some((merchant) => merchant.id === item.id)">
                        {{ item.merchant_name }}
                      </option>
                    </optgroup>
                  </select>
                  <label class="sandbox-input" v-if="!isWhitelisted(selectedActiveMerchant)">
                    <input
                      type="checkbox"
                      v-model="isSandboxMode"
                      :disabled="isCheckboxDisabled">
                    Activate sandbox mode to test the invoicing function
                    using test bitcoin (testBTC).
                  </label>
                </div>

                <br />
                <br />
                <div v-if="displayPaymentLinkCreation">
                  <h4>Insert your payment request details</h4>
                  <label for="payer-email">Payer's name (Individual or Company)</label>
                  <div class="mb-3">
                    <vs-input
                      class="inputx w-full"
                      :danger="validateNameError"
                      danger-text="Please insert payer's full name."
                      v-model.trim="payerName"
                      id="payer-name" />
                    <small
                      class="text-danger"
                      v-if="displayPayerNameValidationError">
                      Please remove numeric from the input and no special
                      characters are allowed as prefix and suffix (eg. '-', '@',
                      etc)
                    </small>
                  </div>

                  <label for="payer-email">Payer's email <span style="color: #ff0000">*</span></label>
                  <vs-input
                    class="inputx mb-3 w-full"
                    :danger="validateEmailError"
                    danger-text="Please provide a correctly formatted e-mail address."
                    data-placeholder="E-mail for payment notification (optional)"
                    data-label="Email to receive payment notification"
                    v-model.trim="notificationEmail"
                    id="payer-email" />
                  <vs-row class="mt-4">
                    <label for="payer-email">Description<span style="color: #ff0000">*</span></label>
                    <vs-textarea
                      id="invoice-description"
                      v-model="invoiceDescription"
                      :class="{ 'red-border': validateInvoiceDescriptionError }">
                    </vs-textarea>
                    <label
                      v-if="validateInvoiceDescriptionError"
                      style="margin-top: -15px; color: #b73a4a"><small>Please insert a description for payment request</small></label>
                  </vs-row>
                  <vs-row class="mt-1 mb-1">
                    <label for="payer-email">Invoice Reference (Order Id)</label>
                    <vs-textarea
                      id="invoice-reference"
                      v-model="invoiceReference">
                    </vs-textarea>
                  </vs-row>
                  <vs-row>
                    <vs-col
                      vs-type
                      vs-justify="left"
                      vs-align="center"
                      vs-w="6"
                      vs-xs="12"
                      class="p-0 pr-3">
                      <label for="currencies-selection">Currency <span style="color: #ff0000">*</span></label>
                      <v-select
                        :options="currencies"
                        :clearable="false"
                        :class="{ 'red-border': validateCurrencyError }"
                        label="Existing wallet"
                        v-model="selectedCurrency"
                        class="d-inline-block w-full"
                        id="currencies-selection"></v-select>
                      <label
                        v-if="validateCurrencyError"
                        style="color: #b73a4a"
                        class="span-text-validation"><small>Please select a currency</small></label>
                    </vs-col>
                    <vs-col
                      vs-type
                      vs-justify="left"
                      vs-align="center"
                      vs-w="6"
                      vs-xs="12"
                      style="padding: 0">
                      <label for="invoice-amount">Invoice Amount
                        <span style="color: #ff0000">*</span></label>
                      <vs-input
                        class="mb-3 d-inline-block w-full"
                        :danger="validateAmountError"
                        danger-text="Please indicate the amount."
                        type="number"
                        step="0.001"
                        min="0.001"
                        data-placeholder="Invoice amount"
                        v-model="invoiceAmount"
                        id="invoice-amount"
                        :disabled="selectedCurrency === null" />
                    </vs-col>
                  </vs-row>

                  <vs-row class="mt-3 mb-3" v-if="showInvoiceUploadField">
                    <label for="payer-email">Upload invoice document or file
                      <span style="color: #ff0000">*</span></label>
                    <template>
                      <vs-row>
                        <template>
                          <VueFileAgent
                            class="w-100"
                            ref="vueFileAgent"
                            :theme="'list'"
                            :accept="'image/*,.pdf'"
                            :deletable="true"
                            :multiple="false"
                            :maxFiles="1"
                            :maxSize="'20MB'"
                            :helpText="'Upload an invoice for your payment request'"
                            v-model="fileRecords"
                            @beforedelete="onBeforeDelete($event)" />
                        </template>
                        <label
                          style="color: #b73a4a"
                          v-if="validateInvoiceEmptyError">Please upload an invoice or supporting document for
                          your payment request</label>
                      </vs-row>
                    </template>
                  </vs-row>

                  <vs-row class="mb-5">
                    <small style="color: red" v-if="createPaymentRequestError">
                      <ul>
                        <li
                          v-for="(
                            reason, index
                          ) in createPaymentRequestErrorReasons"
                          style="font-weight: 500; color: red"
                          :key="index">
                          {{ reason }}
                        </li>
                      </ul>
                    </small>
                  </vs-row>

                  <label name="terms-and-conditions" class="terms-and-cond ml-2">
                    <input
                      type="checkbox"
                      id="terms-and-conditions"
                      v-model="termsAndConditions" />
                    I have read and agreed to the
                    <a
                      href="https://static.triple-a.io/assets/docs/terms_of_use_crypto_payment.pdf"
                      target="_blank"
                      rel="noreferrer noopener">Terms & Conditions</a>
                  </label>


                  <vs-row>
                    <vs-button
                      class="w-100 vs-con-loading__container"
                      data-click="verified2FA ? startPaymentRequest() : show2faPrompt = true"
                      @click="
                        enabled2FA
                          ? (show2faPrompt = true)
                          : startPaymentRequest()
                        "
                      id="create-payment-request-btn"
                      :disabled="!createPaymentRequestButtonEnabled">
                      Create a payment request
                    </vs-button>
                  </vs-row>
                </div>
                <div v-else>
                  <p>
                    You do not have permission to view or access this page for
                    this merchant.
                  </p>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
    <email-password-prompt
      :login="$store.state.activeUser.email"
      :active.sync="show2faPrompt"
      @verify="
        verified2FA = true;
      startPaymentRequest($event);
      " />
  </main>
</template>

<script>
import Vue from 'vue';
import EmailPasswordPrompt from '@/components/EmailPasswordPrompt';
import vSelect from 'vue-select';
import { mapGetters, mapActions } from 'vuex';
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
//
Vue.use(VueFileAgent);
Vue.use(VueFileAgentStyles);
import { debounce } from '../../plugins/debounceHelper';
import { SUPPORTED_FIAT_CURRENCIES } from '@/constants.js';

export default {
  components: {
    vSelect,
    EmailPasswordPrompt,
  },
  data() {
    return {
      show2faPrompt: false,
      verified2FA: false,
      debugConsoleLog: false,
      selected: null,
      selectedAccount: null,
      currencies: SUPPORTED_FIAT_CURRENCIES,
      selectedCurrency: null,
      notificationEmail: '',
      invoiceAmount: null,
      invoiceNumber: null,
      invoiceDescription: '',
      invoiceReference: '',
      account: null,
      initialSelectedAccount: null,
      /** Form validation **/
      formSubmitted: false,
      validateNameError: false,
      validateEmailError: false,
      validateAmountError: false,
      validateCurrencyError: false,
      validateSelectedAccountError: false,
      validateInvoiceNumberError: false,
      validateInvoiceDescriptionError: false,
      validateInvoiceEmptyError: false,

      /** UI toggle bools **/
      displayCopiedMsg: false,
      /** Generated result **/
      url: '',
      shortUrl: '',
      removeBtnStatus: true,
      requestBody: null,
      cart: null,
      shippingCost: null,
      shippingDisc: null,
      taxCost: null,
      invoiceUrlNotAvailable: false,

      paymentRequestCreated: false,
      // emailSent : true,

      showInvoiceUploadField: false,
      payerName: '',

      fileRecords: [],
      s3Data: null,
      paymentReference: null,
      sendEmailSuccessful: false,

      createPaymentRequestError: false,

      //merchant-based
      activeMerchant: null,
      selectedActiveMerchant: null,

      isSandboxMode: false,

      //displays content depends on the user's permission
      displayPaymentLinkCreation: false,

      enabled2FA: false,
      payerIsBlocked: false,

      termsAndConditions: false,

      createPaymentRequestErrorReasons: [],
    };
  },
  mounted() {
    this.account = this.activeAccountGetter;
    if (!this.account || !this.account.apiId) {
      console.debug('No active wallet found.');
      // this.initialSelectedAccount = null;

      console.debug('Creating bank account for the current user.');
    } else {
      if (this.debugConsoleLog)
        console.debug('Active wallet info: ', this.account);
      //this.initialSelectedAccount = this.account.apiId;
      this.setSelectedAccount(this.account.apiId);

      if (this.debugConsoleLog) console.log('Accounts', this.accounts);

      if (this.debugConsoleLog)
        console.log('Merchant List,', this.merchantsGetter);

      //Merchants based
      this.activeMerchant = this.storedActiveMerchantGetter;
      if (this.debugConsoleLog)
        console.log('Active Merchant', this.activeMerchant);

      this.selectedActiveMerchant = this.storedActiveMerchantGetter;

      //check the permission of the user in the default selected merchant
      let currentActiveMerchantId =
        this.selectedActiveMerchant && this.selectedActiveMerchant.id;
      // console.log("Current Active Merchant Id", currentActiveMerchantId);

      //determine to show if the user has permission to see the payment link creation or not
      this.displayPaymentLinkCreation = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'invoices',
        'W'
      );
      // console.log("Content Is Displayed", this.displayPaymentLinkCreation);

      //check if 2FA is enabled for selected Merchant
      this.enabled2FA = this.is2faEnabled(
        this.selectedActiveMerchant,
        'manual_invoice'
      );

      // enabled testBTC immediately as merchant only has 1 api id (testBTC API ID)
      this.isSandboxMode = this.isCheckboxDisabled ? true : false;

      // preselect currency for better UX
      if (this.selectedActiveMerchant) {
        this.selectedCurrency = this.selectedActiveMerchant.kyc_currency;
      }
    }
  },
  computed: {
    ...mapGetters([
      'activeAccountGetter',
      'merchantsGetter',
      'activeMerchantGetter',
      'storedActiveMerchantGetter',
      'currentActiveEntityAdminGetter',
    ]),

    displayPayerNameValidationError() {
      return this.validatePayerName(this.payerName);
    },

    createPaymentRequestButtonEnabled() {
      // only enabled the button when below conditions are true
      return (
        this.notificationEmail &&
        this.invoiceDescription &&
        this.selectedCurrency &&
        this.invoiceAmount &&
        this.termsAndConditions
      );
    },

    checkMerchantsToDisplay() {
      //returns an array of merchants this user has permission to
      return this.hasGroupPermissionToMerchants(
        this.currentActiveEntityAdminGetter
      );
    },

    selectedMerchant() {
      if (this.merchantsGetter.length > 0) {
        if (this.selectedAccount) {
          let apiId = this.selectedAccount.value;
          // console.log("ApiId", apiId);
          for (let i = 0; i < this.merchantsGetter.length; i++) {
            if (
              this.merchantsGetter[i].accounts.find(
                (item) => item.api_id === apiId
              )
            ) {
              return this.merchantsGetter[i];
            }
          }
        }
      }
    },
    accountsList() {
      let accountsGroup = [];

      let arrMain = [];
      let arrTestnet = [];

      for (let item of this.$store.state.accounts) {
        if (item.apiId.includes('_t')) {
          arrTestnet.push(item);
        } else {
          arrMain.push(item);
        }
      }

      let mainAccObj = {
        title: 'Main Account',
        group: arrMain,
      };

      let testnetAccObj = {
        title: 'Testnet Account',
        group: arrTestnet,
      };
      accountsGroup.push(mainAccObj);
      accountsGroup.push(testnetAccObj);

      return accountsGroup;
    },

    accounts() {
      //sort the list so the one with testnet will be on the last
      let arr1 = [];
      let arr2 = [];

      // arr2.push({name : 'Main Account'});
      // arr1.push({name : 'Testnet Account'});

      for (let item of this.$store.state.accounts) {
        if (item.apiId.includes('_t')) {
          arr1.push(item);
        } else {
          arr2.push(item);
        }
      }
      let sortedAccounts = arr2.concat(arr1);
      // console.log("Sorted Accounts", sortedAccounts);

      return (sortedAccounts || []).map((account) => {
        return {
          label: account.name,
          value: account.apiId,
          cryptoCurrency: account.cryptoCurrency,
        };
      });
    },
    mainAccountsList() {
      let arr = [];
      (this.accounts || []).forEach((account) => {
        if (!account.value.includes('_t')) {
          arr.push(account);
        }
      });
      return arr;
    },
    testnetAccountsList() {
      let arr = [];
      (this.accounts || []).forEach((account) => {
        if (account.value.includes('_t')) {
          arr.push(account);
        }
      });
      return arr;
    },

    merchantList() {
      let merchants =
        this.merchantsGetter.length > 0 ? this.merchantsGetter : [];
      return merchants;
    },

    isCheckboxDisabled() {
      return (
        this.selectedActiveMerchant &&
        this.selectedActiveMerchant.accounts.length === 1 &&
        this.selectedActiveMerchant.accounts[0].crypto_currency === 'testBTC'
      );
    },
  },
  watch: {
    accounts: function () {
      if (this.initialSelectedAccount === null) {
        if (this.account) {
          this.setSelectedAccount(this.account.apiId);
        }
      }
    },
    selectedActiveMerchant: function (newVal, oldVal) {
      //check the permission of the user in the default selected merchant
      let currentActiveMerchantId = newVal && newVal.id;

      //determine to show if the user has permission to see the payment link creation or not
      this.displayPaymentLinkCreation = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'invoices',
        'W'
      );

      //check if 2FA is enabled for selected Merchant
      this.enabled2FA = this.is2faEnabled(
        this.selectedActiveMerchant,
        'manual_invoice'
      );

      if (this.invoiceAmount) {
        this.checkCurrency();
      }

      // enabled testBTC immediately as merchant only has 1 api id (testBTC API ID)
      this.isSandboxMode = this.isCheckboxDisabled ? true : false;

      // preselect currency for better UX
      if (newVal) {
        this.selectedCurrency = newVal.kyc_currency;
      }
    },
    storedActiveMerchantGetter(newVal) {
      this.selectedActiveMerchant = newVal;
    },
    invoiceAmount: debounce(function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.checkCurrency();
      }
    }, 1000),

    selectedCurrency: debounce(function (newVal, oldVal) {
      if (this.debugConsoleLog)
        console.log('new currency selected', newVal, oldVal);
      if (this.invoiceAmount) {
        this.checkCurrency();
      }
    }, 1000),
  },
  methods: {
    ...mapActions([
      'checkExchangeRate',
      'getInvoiceUploadData',
      'uploadInvoice',
      'createPaymentRequest',
      'sendEmailToPayer',
      'getMerchantPaymentRequestToken',
    ]),

    checkCurrency() {
      //check the currency and convert it based on the merchant kyc level
      if (this.debugConsoleLog)
        console.log(
          'Check merchant kyc levels',
          this.selectedMerchant.kyc_levels
        );
      if (this.debugConsoleLog)
        console.log(
          'Check merchant kyc currency',
          this.selectedMerchant.kyc_currency
        );

      //check the exchange rate
      let payload = {};
      payload.api_id = this.selectedAccount.value;
      payload.from_currency = this.selectedMerchant.kyc_currency;
      payload.to_currency = this.selectedCurrency;

      if (payload.from_currency && payload.to_currency) {
        this.checkExchangeRate(payload)
          .then((res) => {
            if (this.debugConsoleLog)
              console.log('Get exchange rate', res.data);

            // this.$vs.loading.close('#payment-request-container > .con-vs-loading')

            let exchangeRate = res.data.exchange_rate;

            let amountForInvoiceUploading = this.invoiceAmount / exchangeRate;
            if (this.debugConsoleLog)
              console.log(
                'Amount for invoice uploading',
                amountForInvoiceUploading
              );

            this.showInvoiceUploadField = amountForInvoiceUploading > this.selectedMerchant.invoice_upload_threshold &&
              !this.isWhitelisted(this.selectedActiveMerchant);
          })
          .catch((err) => {
            console.log('Error in getting exchange rate', err);
          });
      }
    },

    createAnotherPaymentRequest() {
      this.paymentRequestCreated = false;
      this.payerName = '';
      this.notificationEmail = '';
      this.selectedCurrency = null;
      this.invoiceDescription = '';
      this.invoiceReference = '';
      (this.invoiceAmount = null), (this.createPaymentRequestError = false);
      this.sendEmailSuccessful = false;
      this.fileRecords = [];
      this.showInvoiceUploadField = false;
      this.isSandboxMode = false;

      this.termsAndConditions = false;
      this.createPaymentRequestErrorReasons = [];
    },

    createInvoice(eventPayload) {
      const payload = {};
      payload.data = {
        type: 'invoice',
        payer_id: this.notificationEmail,
        merchant_key: this.selectedActiveMerchant.merchant_key,
        order_amount: this.invoiceAmount,
        order_currency: this.selectedCurrency,
        invoice_desc: this.invoiceDescription,
        sandbox: this.isSandboxMode ? true : false,
      };
      if (this.s3Data) {
        payload.data['invoice_url'] = this.s3Data.fields.key;
      }
      if (this.payerName) {
        payload.data['payer_name'] = this.payerName;
      }
      if (this.invoiceReference) {
        payload.data['order_id'] = this.invoiceReference.trim();
      }

      if (eventPayload && Object.keys(eventPayload).length > 0) {
        payload.data.username = this.currentActiveEntityAdminGetter.email;
        payload.data[`${Object.keys(eventPayload)[0]}`] = this.encryptPassword(Object.values(eventPayload)[0], this.currentActiveEntityAdminGetter.email);
      }

      if (this.debugConsoleLog) {
        console.log('Payload for payment request', payload);
      }

      this.createPaymentRequest(payload)
        .then((res) => {
          if (this.debugConsoleLog) {
            console.log('Payment Request result', res);
          }

          this.$vs.loading.close(
            '#create-payment-request-btn > .con-vs-loading'
          );

          this.url = res.data.hosted_url;
          this.paymentReference = res.data.payment_reference;

          this.paymentRequestCreated = true;
          this.createPaymentRequestError = false;
        })
        .catch((err) => {
          this.invoiceCreationError(err);
          this.$vs.loading.close(
            '#create-payment-request-btn > .con-vs-loading'
          );
        });
    },

    startPaymentRequest(eventPayload) {
      //validation
      if (!this.notificationEmail || this.notificationEmail.indexOf('@') < 2) {
        this.validateEmailError = true;
      } else {
        this.validateEmailError = false;
      }

      if (!this.selectedCurrency) {
        this.validateCurrencyError = true;
      } else {
        this.validateCurrencyError = false;
      }

      if (!this.invoiceAmount) {
        this.validateAmountError = true;
      } else {
        this.validateAmountError = false;
      }

      if (!this.invoiceDescription) {
        this.validateInvoiceDescriptionError = true;
      } else {
        this.validateInvoiceDescriptionError = false;
      }

      if (this.showInvoiceUploadField && this.fileRecords.length <= 0) {
        this.validateInvoiceEmptyError = true;
      } else {
        this.validateInvoiceEmptyError = false;
      }

      if (
        this.validateNameError ||
        this.validateEmailError ||
        this.validateCurrencyError ||
        this.validateAmountError ||
        this.validateInvoiceDescriptionError ||
        this.validateInvoiceEmptyError
      ) {
        return;
      }

      if (this.showInvoiceUploadField && this.fileRecords.length > 0) {
        let data = {};
        data.mimeType = this.fileRecords[0].type;
        data.merchantKey = this.selectedMerchant.merchant_key;

        if (this.debugConsoleLog) console.log('Data', data);

        this.getInvoiceUploadData(data)
          .then((res) => {
            if (this.debugConsoleLog)
              console.log('Get invoice upload data res', res.data);

            this.$vs.loading({
              container: '#create-payment-request-btn',
              scale: 0.45,
              color: 'primary',
            });

            this.s3Data = res.data;

            let payload = {};
            payload.contentType = this.fileRecords[0].type;
            payload.file = this.fileRecords[0].file;
            payload.uploadInvoiceData = this.s3Data;

            // If need to upload an invoice
            this.uploadInvoice(payload)
              .then((res) => {
                if (this.debugConsoleLog)
                  console.log('Upload invoice Res', res);
                this.createPaymentRequestError = false;

                if (res.status === 204) {
                  if (this.debugConsoleLog)
                    console.log('Start Getting invoice Token');
                  this.createInvoice(eventPayload);
                }
              })
              .catch((err) => {
                console.log('Error in uploading invoice', err);
                this.invoiceCreationError(err);
                this.$vs.loading.close(
                  '#create-payment-request-btn > .con-vs-loading'
                );
              });
          })
          .catch((err) => {
            console.log('Get invoice upload data error', err);
            this.invoiceCreationError(err);
            this.$vs.loading.close(
              '#create-payment-request-btn > .con-vs-loading'
            );
          });
      }
      //no need to upload an invoice, can immediately make the payment request
      else {
        this.createInvoice(eventPayload);
      }
    },

    sendEmail() {
      if (this.paymentReference) {
        let payload = {};
        payload.paymentReference = this.paymentReference;

        this.sendEmailToPayer(payload)
          .then((res) => {
            if (this.debugConsoleLog) console.log('Send email to payer', res);

            if (res.data.payment_reference) {
              setTimeout(() => {
                this.sendEmailSuccessful = true;
              }, 1000);
            }
          })
          .catch((err) => {
            console.log('Send Email to payer error', err);
            this.sendEmailSuccessful = false;
          });
      } else {
        console.log('Payment reference does not exist. please try again.');
      }
    },

    setSelectedAccount(apiId) {
      for (let i = 0; i < this.accounts.length; ++i) {
        if (this.accounts[i].value === apiId) {
          this.initialSelectedAccount = this.selectedAccount = this.accounts[i];
          break;
        }
      }
    },

    setSelectedMerchant(merchantKey) {
      for (let i = 0; i < this.merchantList.length; i++) {
        if (this.merchantList[i].merchant_key === merchantKey) {
          this.selectedActiveMerchant = this.merchantList[i];
          break;
        }
      }
    },
    copyLink() {
      if (this.shortUrl) this.copyToClipboard(this.shortUrl);
      else this.copyToClipboard(this.url);

      this.displayCopiedMsg = true;
      setTimeout(() => {
        this.displayCopiedMsg = false;
      }, 2000);
    },

    //method for vue file agent
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(fileRecord);
    },
    onBeforeDelete: function (fileRecord) {
      this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
    },

    fileDeleted: function (fileRecord) {
      this.deleteUploadedFile(fileRecord);
    },

    invoiceCreationError(err) {
      // reset errors
      this.createPaymentRequestError = false;
      this.createPaymentRequestErrorReasons = [];

      this.createPaymentRequestError = true;
      if (
        err.response.status === 403 ||
        err.response.status === 404
      ) {
        this.createPaymentRequestErrorReasons.push(
          'Error in creating payment request. Please refresh and try again or contact support for assistance to investigate this case further.'
        );
      } else if(err.response.status === 401) {
        this.createPaymentRequestErrorReasons.push(
          'Error in authorising invoice creation. Please try again.'
        );
      }
       else if (
        err.response.status === 400 &&
        err.response.data.message === 'payer_is_blocked'
      ) {
        this.createPaymentRequestErrorReasons.push(
          'Payment request is not available for this recipient as it has failed our compliance check.'
        );
      } else if (
        err.response.status === 409 &&
        err.response.data.message === 'payer_exceed_send_limits'
      ) {
        this.createPaymentRequestErrorReasons.push(
          'Payment request is not available for this recipient as it has surpassed the limit of this payment.'
        );
      } else if (err.response.status === 422) {
        const formErrors = [];
        if(err.response.data.errors) {
          for (let e of err.response.data.errors) {
            formErrors.push(this.formatErrMessage(e));
          }
        }

        if (formErrors.length == 0 && err.response.data) {
          formErrors.push(this.formatErrMessage(err.response.data));
        }
        this.createPaymentRequestErrorReasons.push(
          'The payment details are incorrect, your request has been rejected. Please check again : '.concat(
            formErrors.join(', ')
          )
        );
      } else {
        this.createPaymentRequestErrorReasons.push(
          'Something went wrong, no payment/invoice has been created. Please check your request details and try again.'
        );
      }
    },
    formatErrMessage(error) {
      if (error.path) {
        return error.message + ' ' + error.path.replace(/_/g, ' ');
      } else {
        return error.message.replace(/_/g, ' ');
      }
    },
    isWhitelisted(merchant) {
      if (!merchant || !merchant.merchant_key) return false;
      const whitelistedMerchants = [
        'mkey-ckcd2j2md0000zkqs3kueb19s', // staging test

        'mkey-clmfy2btz0000etdj7ij0emlx',
        'mkey-clmg63uvf0000mwdjeyc5hlqm',
        'mkey-clmh3y10y00006kdjephmfywl',
        'mkey-clmh40uh40000nudj9vti02is',
        'mkey-clmh42ucf00000ldjbimr4qvh',
        'mkey-clodwxnnj001t7wmzb5qqh4fl',
        'mkey-clodx01nz001w7wmz6bcvg3cq',
        'mkey-clodx0ubd001z7wmz88wxcirh',
        'mkey-clodx1cf100227wmzc04g96ct',
        'mkey-clodx1qp800257wmz056y6jqp',
        'mkey-clodx2cdx00287wmzevw0cop3',
        'mkey-clodx2t41002b7wmz9smqgqso',
        'mkey-clodx3elm002e7wmza4schhaf',
        'mkey-clodx3qg2002h7wmzeq9k3xjk',
        'mkey-clodx42ji002k7wmz4lircue5',
        'mkey-clodx4elv002n7wmz19yhfq7t',
        'mkey-clodx4q2v002q7wmzarbh0yt8',
        'mkey-clodx4z4i002t7wmz0irgawzc',
        'mkey-clodx5980002w7wmzcr5cgiy0',
        'mkey-clodx5mvf002z7wmz4xdleird',
        'mkey-clodx5t8700327wmza7jo0qj1',
        'mkey-clodx5ylq00357wmz03gc8nbh',
        'mkey-clqyxhy2y0000rvdje2518ye0',
      ];
      return whitelistedMerchants.includes(merchant.merchant_key);
    },
  },
};
</script>

<style>
.red-border .vs__dropdown-toggle,
.red-border #invoice-description {
  border: 1px solid rgba(var(--vs-danger), 1) !important;
}

/*.red-border{*/
/*  border: 1px solid rgba(var(--vs-danger), 1) !important;*/
/*}*/

.copiedMsg {
  position: absolute;
  right: -20px;
  bottom: 30px;
  text-align: center;
  background-color: #2774b1;
  border-radius: 5px;
  color: #ffffff;
}

.style-select .vs__dropdown-option {
  color: blue;
}

.accountSelection {
  height: 36px;
  border-radius: 5px;
  border: 0.5px solid #cdcdcd;
  padding: 3px;
  color: dimgrey;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.btn-style {
  border: none;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  font-weight: bold;
}

.optionalInput {
  height: 36px;
  border-radius: 5px;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  color: dimgrey;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 14px;
  padding: 0.7rem;
}

.optionalInput:focus {
  height: 36px;
  border-radius: 5px;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  color: dimgrey;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 14px;
  padding: 0.7rem;
}

label {
  font-size: 10px;
}

.optionalLabel {
  color: #505050;
}

.tooltip-copy-container,
.tooltip-clear-container {
  position: relative;
}

.tooltip-clear-msg {
  position: absolute;
  right: 5px;
  bottom: -37px;
  width: 50px;
  padding: 5px;
  text-align: center;
  background-color: #b73a4a;
  border-radius: 5px;
  color: #eeeeee;
  visibility: hidden;
}

.tooltip-clear-container:hover .tooltip-clear-msg {
  visibility: visible;
}

.payment-link-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 10px;
}

.payment-link {
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  padding: 6px;
  width: 95%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-url {
  display: flex;
  justify-content: center;
  border: 1px solid black;
  border-radius: 3px;
  align-items: center;
}

.vs__dropdown-menu {
  z-index: 9999999;
}

.sandbox-input {
  font-size: small;
  display: flex;
  width: fit-content;
  align-items: center;
}

.sandbox-input>input {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}

.terms-and-cond {
  display: flex;
  margin-bottom: 12px;
  flex-grow: 0;
  flex-basis: auto;
  width: fit-content;
}

.terms-and-cond>input {
  margin-right: 3px;
  height: 16px;
  width: 16px;
}

.terms-and-cond a {
  margin-left: 3px;
}

h4 {
  margin-bottom: 12px;
}
</style>
